// removed by extract-text-webpack-plugin
module.exports = {"container":"_37gzu-KckqzFzCUimNvzRQ","mainContent":"_2MbOB_EJaiG9F1qsa11JGP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/page.css
// module id = 1097
// module chunks = 0